module.exports = require('dompack/src/events');



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/system/nodejs/dom/events.js
// module id = 1013
// module chunks = 0